import { Clause, ClauseType } from '../types';
import { DraftClause } from '../../../types/drafting';

const KNOWN_CLAUSE_TYPES = new Set<ClauseType>([
  'interpretation',
  'parties_relationship',
  'services',
  'term',
  'fees_payment',
  'obligations',
  'representations_warranties',
  'liability',
  'indemnity',
  'remedies',
  'insurance',
  'confidentiality',
  'privacy_data_protection',
  'intellectual_property',
  'compliance',
  'termination',
  'exit_assistance',
  'force_majeure',
  'dispute_resolution',
  'governing_law',
  'change_of_control',
  'notices',
  'entire_agreement',
  'service_levels',
  'support_maintenance',
  'audit',
  'general',
]);

function coerceClauseType(raw: string): ClauseType {
  return KNOWN_CLAUSE_TYPES.has(raw as ClauseType)
    ? (raw as ClauseType)
    : 'general';
}

/**
 * Plan 183: render `draft_clauses` rows in Desk's ClauseCard, which expects
 * the document-side `Clause` shape. Drafts have no document-side metadata
 * (no page anchors, no logical_id, no start_char/end_char) — those fields
 * are omitted, and ClauseCard's branches that depend on them simply don't
 * trigger.
 */
export function draftClauseToClause(dc: DraftClause): Clause {
  return {
    id: dc.id,
    title: dc.title,
    type: coerceClauseType(dc.clause_type),
    content: dc.content,
    position: dc.section_order,
  };
}
